import { render } from "./WidgetStories.vue?vue&type=template&id=2a1540a4"
import script from "./WidgetStories.vue?vue&type=script&lang=js"
export * from "./WidgetStories.vue?vue&type=script&lang=js"

import "./WidgetStories.vue?vue&type=style&index=0&id=2a1540a4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__